import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {useTranslation} from "react-i18next";

export const ConfirmDialog: React.FC<{open: boolean, onClose: any, text: string, title: string}> = ({open, onClose, text, title}) => {
    const { t } = useTranslation('common');

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(true);
    };

    return (
        <Dialog
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
            open={open}
        >
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent dividers>
                {text}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel} color="primary">
                    {t('confirmModal.cancel')}
                </Button>
                <Button onClick={handleOk} color="primary">
                    {t('confirmModal.yes')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
